import { useRiskRegisterStore } from 'store/riskRegister.store';
import { useThemeStatusStore } from 'store/themeStatus.store';

import { UseRiskDriversProvider } from 'components/widgets/RiskDrivers/RiskDrivers.provider';
import { exportCsvHeaders, options, series } from 'components/widgets/RiskDrivers/RiskDrivers.utils';

interface Props {
    api: UseRiskDriversProvider['api'];
    ui: UseRiskDriversProvider['ui'];
}

export const useRiskDriversLogic = ({ api, ui }: Props) => {
    const { themeStatus } = useThemeStatusStore();
    const { taskVersionLabel, numOfIterations } = useRiskRegisterStore();

    const impactTypeData =
        api.riskDrivers.data?.tornadoResponse?.find((item) => item.impactType === ui.state.impactType.value)
            ?.tornadoRisks ?? [];

    const rowCount = impactTypeData.length;
    const pixelsPerRow = 100;
    const chartHeight = Math.max(400, rowCount * pixelsPerRow);

    return {
        logic: {
            series: series({ data: impactTypeData }),
            options: options({ data: impactTypeData, themeStatus }),
            chartHeight,
            taskVersionLabel,
            numOfIterations,
            exportCsv: {
                headers: exportCsvHeaders({ impactType: ui.state.impactType }),
                rows: impactTypeData.map((row) => ({
                    riskId: row.riskId,
                    riskName: row.riskName,
                    riskValue: row.impactValue,
                    riskUid: row.riskUid,
                })),
                fileName: 'Risk-Drivers-Drivers',
            },
        },
    };
};
